module.exports = __webpack_public_path__ + "img/main.7eb68a2f.jpg";